import React, { useState } from 'react';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';

import { DraggableLinkTableRow } from './DraggableLinkTableRow';

import { useUpdateLinkLibraryMutation } from 'hooks/query/useQuickLinksQuery';

import DndContextComponent from 'components/common/sortableDnD/DndContextComponent';

import { formattedUpdateWeightBody } from 'utils/linkLibrary';

import type { LinkLibraryLinkRow } from 'interface/linkLibraryTree';

interface Props {
  links: LinkLibraryLinkRow[];
  nodeLevel: number;
  activePopoverId: string | null;
  setActivePopoverId: React.Dispatch<React.SetStateAction<string | null>>;
}

const LinkTable: React.FC<Props> = ({ links, nodeLevel, activePopoverId, setActivePopoverId }) => {
  const [draftState, setDraftState] = useState(() => ({
    sourceLinks: links,
    linkListData: [...(links || [])],
  }));
  const linkListData = draftState.sourceLinks === links ? draftState.linkListData : [...(links || [])];

  const { mutate } = useUpdateLinkLibraryMutation();

  const onDragEnd = (items: LinkLibraryLinkRow[]) => {
    const bodyPayload = formattedUpdateWeightBody(items);

    setDraftState({ sourceLinks: links, linkListData: items });
    mutate(bodyPayload);
  };

  return (
    <div className={`link-table-wrapper paddingNested-${nodeLevel}`}>
      <DndContextComponent listData={linkListData} onDragEnd={onDragEnd}>
        <table className="link-table">
          <thead>
            <tr>
              <th></th>
              <th>Link Name</th>
              <th>Link Url</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <SortableContext items={linkListData.map(({ id }) => id)} strategy={verticalListSortingStrategy}>
              {linkListData.map((data) => (
                <DraggableLinkTableRow
                  key={`${data.id}-${data.name}`}
                  rowData={data}
                  activePopoverId={activePopoverId}
                  setActivePopoverId={setActivePopoverId}
                />
              ))}
            </SortableContext>
          </tbody>
        </table>
      </DndContextComponent>
    </div>
  );
};

export default LinkTable;
